import unSupportedImage from 'assets/image/snail-no.png'
import { FC, ReactElement } from 'react'
import { useParams } from 'react-router'

import classes from './UnSupportedContent.module.scss'

interface Props {
	eventName: string
}

export const UnSupportedContent: FC<Props> = ({ eventName }): ReactElement => {
	const { conversation } = useParams<{ conversation?: string }>()

	return (
		<div className={classes.wrapper}>
			<img alt="Unsupported content" className={classes.image} src={unSupportedImage} width={36} />

			<div className={classes.content}>
				<p>{eventName} is not fully supported at snaily.</p>

				{conversation && (
					<p>
						Use
						<a
							className={classes.link}
							href={`https://www.linkedin.com/messaging/thread/${conversation}`}
							rel="noopener noreferrer"
							target="_blank"
						>
							this link
						</a>
						to view it at Linkedin
					</p>
				)}
			</div>
		</div>
	)
}